export default __webpack_public_path__ + "static/media/ic-player-forward.cc33650b.svg";